import React, { Dispatch, SetStateAction, useState } from 'react';
import { useIntl } from 'react-intl';

import { Button, List, Popper } from '@xsolla/ui-core';
import { ChevronDownMini } from '@xsolla/ui-icons';

import { IGetParams } from '../../../hooks/types';
import { StatusUserSelect, UserStatusBlock } from './style';
import { GroupFilter } from './types';

type Props = {
  setStatus: Dispatch<SetStateAction<IGetParams>>;
};

export const UserStatusSelect = ({ setStatus }: Props): JSX.Element => {
  const intl = useIntl();
  const [userStatus, setUserStatus] = useState<string>(GroupFilter.all);

  const setNewStatus = (params: IGetParams) => {
    setStatus((prev) => ({
      ...prev,
      status: params.status
    }));
  };

  const userStatusItems = [
    {
      children: intl.messages[`users.list-block.select-mode.all`],
      onClick: () => {
        setUserStatus(GroupFilter.all);
        setNewStatus({});
      },
      'data-test-id': 'status-all'
    },
    {
      children: intl.messages[`users.list-block.select-mode.active`],
      onClick: () => {
        setUserStatus(GroupFilter.active);
        setNewStatus({
          status: 1
        });
      },
      'data-test-id': 'status-active'
    },
    {
      children: intl.messages[`users.list-block.select-mode.ban`],
      onClick: () => {
        setUserStatus(GroupFilter.ban);
        setNewStatus({
          status: 0
        });
      },
      'data-test-id': 'status-ban'
    }
  ];

  return (
    <UserStatusBlock>
      <Popper
        arrowOffset={32}
        entry={<List items={userStatusItems} />}
        offset={6}
        placement="bottom-start"
        stretched>
        {(referenceProps) => (
          <Button {...referenceProps} look="link" size="md" data-test-id="select-status">
            <StatusUserSelect>
              {intl.messages[`users.list-block.select-mode.${userStatus || GroupFilter.all}`]}
              <ChevronDownMini />
            </StatusUserSelect>
          </Button>
        )}
      </Popper>
    </UserStatusBlock>
  );
};
